import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { WorkshopModel } from '../../models/workshop.model';
import { RegistrationApprovalModel } from '../../models/registration-approval.model';
import { ProfileService } from '../../../profile/services/profile.service';
import { PersianTitlesService } from '../../../../core/services/persian-titles.service';

@Component({
  selector: 'app-workshop-card',
  templateUrl: './workshop-card.component.html',
  styleUrls: ['./workshop-card.component.css'],
  standalone: false,
})
export class WorkshopCardComponent implements OnInit, OnDestroy {
  @Input('workshop') workshop: WorkshopModel;
  @Input('canRegister') canRegister: boolean = false;
  @Input('showDescription') showDescription: boolean = false;
  @Input('isRegisteredAndApproved') isRegisteredAndApproved: boolean = false;
  @Input('isRegisteredAndRejected') isRegisteredAndRejected: boolean = false;
  @Input('isRegisteredAndPending') isRegisteredAndPending: boolean = false;
  @Input('requestDate') requestDate: string;
  @Output() onRegister = new EventEmitter<number>();

  subscription: Subscription;

  registrationApprovalProps: RegistrationApprovalModel;

  showApprovalPromptPopup: boolean = false;

  // Labels
  titleLabel: string = '';
  teacherLabel: string = '';
  holdingTypeLabel: string = '';
  holdingDateLabel: string = '';
  locationLabel: string = '';
  daysLeftLabel: string = '';
  registerLabel: string = '';
  registeredAndApprovedLabel: string = '';
  registeredAndPendingLabel: string = '';
  registeredAndRejectedLabel: string = '';
  addToGoogleCalendarLabel: string = '';

  constructor(
    private profileService: ProfileService,
    private persianTitlesService: PersianTitlesService,
  ) {}

  ngOnInit() {
    this.initLabel();
  }

  onRegisterButtonClick(workshopId: number) {
    this.subscription = this.profileService
      .getMyRegistrationApprovalStatus()
      .subscribe((resp) => {
        this.registrationApprovalProps = resp;
        if (this.registrationApprovalProps.hasApprovalForRegistering == false) {
          this.showApprovalPromptPopup = true;
        } else {
          this.onRegister.emit(workshopId);
        }
      });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  private initLabel() {
    this.titleLabel = this.persianTitlesService.Items.Title;
    this.teacherLabel = this.persianTitlesService.Items.Teacher;
    this.holdingDateLabel = this.persianTitlesService.Items.HoldingDate;
    this.holdingTypeLabel = this.persianTitlesService.Items.HoldingType;
    this.locationLabel = this.persianTitlesService.Items.Location;
    this.registerLabel = this.persianTitlesService.Items.Register;
    this.registeredAndApprovedLabel =
      this.persianTitlesService.Items.RegisteredAndApproved;
    this.registeredAndPendingLabel =
      this.persianTitlesService.Items.RegisteredAndPending;
    this.registeredAndRejectedLabel =
      this.persianTitlesService.Items.RegisteredAndRejected;
    this.daysLeftLabel = this.persianTitlesService.Items.DaysLeft;
    this.addToGoogleCalendarLabel =
      this.persianTitlesService.Items.addToGoogleCalendar;
  }
}
